import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Batches from "./pages/Batches";
import Students from "./pages/Students";
import StudentDetail from "./pages/StudentDetail";
import Credits from "./pages/Credits";
import BuyCredits from "./pages/BuyCredits";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/CampaignDetail";
import Results from "./pages/Results";
import Settings from "./pages/Settings";

// Institution admin console — mounted as a DESCENDANT route tree at
// /institution/* inside the consumer app's single BrowserRouter, so the whole
// product (marketing + student app + institution console + API) runs on one
// origin/port. It keeps its OWN auth context: a localStorage bearer token
// (prepxai_inst_token), completely separate from the consumer's cookie session,
// so the two trust boundaries never leak into each other.
//
// Child route paths are RELATIVE (no leading slash) — React Router resolves
// them under the parent "/institution/*" match. All in-app navigation targets
// are written with an explicit "/institution" prefix (see pages/components).
export default function InstitutionApp() {
  return (
    <AuthProvider>
      {/* institution-scope neutralizes the app-wide fluid-type font inflation
          so the console's text renders at the same scale as the rest of the
          app (see .institution-scope rules in styles/tailwind.css). */}
      <div className="institution-scope">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="batches" element={<Batches />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:id" element={<StudentDetail />} />
              <Route path="credits" element={<Credits />} />
              <Route path="buy-credits" element={<BuyCredits />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/:id" element={<CampaignDetail />} />
              <Route path="results" element={<Results />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/institution" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
